import React, { useState } from 'react';
import { Input, Button, Space, Card, Table, Empty } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { usePW9403Query } from './hooks/usePW9403Query';
import type { EmployeeRow } from '../../services/pw9403Api';
import './PW9403Form.css';

const PW9403Form: React.FC = () => {
  const { loading, data, queried, noData, runQuery, reset } = usePW9403Query();
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');

  const handleQuery = () => {
    runQuery({
      deptFrom: deptFrom.trim() || undefined,
      deptTo: deptTo.trim() || undefined,
    });
  };

  const handleReset = () => { setDeptFrom(''); setDeptTo(''); reset(); };

  const columns: ColumnsType<EmployeeRow> = [
    { title: '員工代號', dataIndex: 'emp_no', key: 'emp_no', width: 100 },
    { title: '員工姓名', dataIndex: 'emp_name', key: 'emp_name', width: 120 },
    { title: '部門代號', dataIndex: 'dept_code', key: 'dept_code', width: 80 },
    { title: '部門名稱', dataIndex: 'dept_name', key: 'dept_name', width: 140 },
    { title: '職稱代號', dataIndex: 'title_code', key: 'title_code', width: 80 },
    { title: '職稱名稱', dataIndex: 'title_name', key: 'title_name', width: 140 },
    { title: '到職日', dataIndex: 'hire_date', key: 'hire_date', width: 110, render: (v: string) => v?.substring(0, 10) || '' },
    { title: '年資', dataIndex: 'seniority', key: 'seniority', width: 70, align: 'right' as const, render: (v: number) => v?.toFixed(1) },
  ];

  return (
    <PermissionGuard module={Modules.PW9403} action="query">
      <div className="pw9403-container">
        <div className="pw9403-header"><h2>員工資料查詢-部門</h2></div>
        <Card size="small" style={{ marginBottom: 16 }}>
          <Space wrap size="middle">
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 4 }}>部門代號起</label>
              <Input value={deptFrom} onChange={e => setDeptFrom(e.target.value)} placeholder="起始部門" style={{ width: 130 }} allowClear />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 4 }}>部門代號迄</label>
              <Input value={deptTo} onChange={e => setDeptTo(e.target.value)} placeholder="結束部門" style={{ width: 130 }} allowClear />
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', paddingTop: 18 }}>
              <Space>
                <Button type="primary" icon={<SearchOutlined />} onClick={handleQuery} loading={loading}>查詢</Button>
                <Button icon={<ClearOutlined />} onClick={handleReset}>清除</Button>
              </Space>
            </div>
          </Space>
        </Card>
        {queried && noData && <Empty description="查無符合條件的員工資料" style={{ marginTop: 40 }} />}
        {queried && !noData && (
          <Table<EmployeeRow>
            columns={columns} dataSource={data} rowKey="emp_no" loading={loading} size="small"
            pagination={{ pageSize: 50, showSizeChanger: true, showTotal: t => `共 ${t} 筆` }}
            scroll={{ x: 800 }}
          />
        )}
      </div>
    </PermissionGuard>
  );
};

export default PW9403Form;
